import { forwardRef, useId } from "react";

import { type SvgExtendedProps } from "./types";

const SvgParachute = forwardRef<SVGSVGElement, SvgExtendedProps>(
  ({ gradientStartColor = "#98CCFB", gradientEndColor = "#F6F3F1", ...props }, ref) => {
    const gradientId = useId();

    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={176}
        height={120}
        fill="none"
        viewBox="0 0 176 120"
        {...props}
      >
        <path
          d="M125.239 53.2448C133.692 43.7874 110.098 18 88.8492 18C67.6006 18 42.2137 43.2 50.6667 53.2448M125.239 53.2448C130.009 47.9084 121.144 41.1 114.061 41.1C106.978 41.1 100.003 46.1075 100.003 53.2448M125.239 53.2448L98 86.9231M100.003 53.2448C100.003 46.1075 95.9321 41.1 88.8492 41.1C81.7663 41.1 75.9479 46.1075 75.9479 53.2448M100.003 53.2448L90.1794 86.9231M75.9479 53.2448C75.9479 46.1075 70.4282 41.1 63.3453 41.1C56.2624 41.1 46.0593 47.7698 50.6667 53.2448M75.9479 53.2448L85.8447 86.9231M50.6667 53.2448L78 86.9231M78 86.9231H98M78 86.9231V101.5C78 101.776 78.2239 102 78.5 102H97.5C97.7761 102 98 101.776 98 101.5V86.9231"
          stroke={`url(#${gradientId})`}
          strokeWidth={8}
        />
        <defs>
          <linearGradient
            id={gradientId}
            x1={88}
            x2={88}
            y1={18}
            y2={102}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.195} stopColor={gradientStartColor} />
            <stop offset={1} stopColor={gradientEndColor} />
          </linearGradient>
        </defs>
      </svg>
    );
  }
);

SvgParachute.displayName = "SvgParachute";

export default SvgParachute;
